<template>
  <base-modal :id="tooltipId"
              tabindex="-1"
              size="sm"
              centered
              hide-footer
              hide-header
              no-close-on-backdrop
              no-close-on-esc
              align="center">
    <div class="tooltip-container">
      <div v-if="isAlert"
           class="row no-gutters">
        <div class="col">
          <div class="d-flex align-items-center">
            <inline-svg v-if="displayAlertIcon"
                        src="AlertFilledIcon"
                        class="icon--red">
            </inline-svg>
            <h2 :id="`${tooltipId} HeaderText`"
                class="text-red text-400 text-24"
                align="left">
              {{ headerText }}
            </h2>
          </div>
        </div>
      </div>

      <div v-else
           class="row">
        <div class="col">
          <h2 class="text-heading text-24 text-400">
            {{ headerText }}
          </h2>
        </div>
      </div>

      <div v-if="headerDivider"
           class="line-horizontal spacing-1">
      </div>

      <div :id="`${tooltipId} BodyText`"
           class="row spacing-2">
        <div class="col"
             :align="alignBody">
          <span :class="bodyClass"
                v-html="bodyHTML">
          </span>
        </div>
      </div>

      <div class="row spacing-3">
        <div class="col">
          <button id="toolTipCloseButton"
                  class="btn"
                  :class="buttonClass"
                  type="button"
                  @click="onClose">
            {{ toolTipButtonText }}
          </button>
        </div>
      </div>
    </div>
  </base-modal>
</template>

<script>
// Components
import BaseModal from './BaseModal.vue'
import InlineSvg from './InlineSvg.vue'

// Utilities
import isEmpty from '../../../utility/isEmpty'

export default {
  name: 'tooltip',

  components: {
    BaseModal,
    InlineSvg
  },

  props: {
    buttonText: String,
    bodyHTML: String,
    headerText: String,
    isAlert: Boolean,
    showTooltip: Boolean,

    bodyClass: {
      type: String,
      default: ''
    },

    buttonClass: {
      type: String,
      default: 'button--primary'
    },

    alignBody: {
      type: String,
      default: 'left'
    },

    displayAlertIcon: {
      type: Boolean,
      default: true
    },

    headerDivider: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tooltipId () {
      return this.headerText === undefined ? 'blankTooltip' : `${this.headerText.split(' ')[0]}Tooltip`
    },

    toolTipButtonText () {
      return isEmpty(this.buttonText) ? this.$t('global.close') : this.buttonText
    }
  },

  watch: {
    /**
     * Passing all props, attributes, and listeners down to a child component does not allow v-model to work properly so having to use a watcher to open/close base-modal instead.
     */
    showTooltip (value) {
      setTimeout(() => {
        if (value === true) {
          this.$bvModal.show(this.tooltipId)
        } else {
          this.$bvModal.hide(this.tooltipId)
        }
      }, 100)
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.icon--red {
  max-width: 1.125rem;
  max-height: 1.125rem;
  margin-right: 0.5rem;
}

h2 {
  margin-bottom: 0;
}
</style>
